import { Table, Spinner, ExportWorkBook, Text } from 'components/Elements';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useInActiveCustomers } from '../api/getInactiveCustomers';

export const InactiveCustomers = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const inactiveCustomersQuery = useInActiveCustomers({ pageNumber });

  if (inactiveCustomersQuery.isLoading) {
    return (
      <div className="w-full h-48 flex justify-center items-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!inactiveCustomersQuery.data) return null;

  const columns = [
    {
      title: 'User',
      field: '',
      Cell({ entry: { id, firstName, lastName, photo } }) {
        return (
          <Link
            to={`/app/users/${id}`}
            className="flex flex-row items-center space-x-2 justify-start"
          >
            <img src={photo} alt="Avatar" className="w-4" />
            <Text variant="body">
              {firstName || <Text variant="caption">Missing information</Text>} {lastName}
            </Text>
          </Link>
        );
      },
    },

    {
      title: 'Email',
      field: 'email',
      Cell({ entry: { email } }) {
        return (
          <Text>
            <span>{email}</span>
          </Text>
        );
      },
    },
  ];

  return (
    <>
      <div className="">
        <Table
          data={inactiveCustomersQuery.data?.inActiveUsers}
          columns={columns}
          totalPages={inactiveCustomersQuery.data?.totalPages}
          onPageChange={(newPage) => setPageNumber(newPage)}
        />
      </div>
    </>
  );
};
